import { render, staticRenderFns } from "./HistoryComments.vue?vue&type=template&id=c6badf06&scoped=true"
import script from "./HistoryComments.vue?vue&type=script&lang=js"
export * from "./HistoryComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6badf06",
  null
  
)

export default component.exports